import type { FollowStatus } from '@/src/listings/components/OrganizerCard/types';
import type { Organizer } from '@/src/listings/types';

// Follow action constants
export const FOLLOW_ACTION = 'follow';
export const UNFOLLOW_ACTION = 'unfollow';

export type FollowAction = typeof FOLLOW_ACTION | typeof UNFOLLOW_ACTION;

export enum FollowButtonVariant {
  Default = 'default',
  Organizer = 'organizer',
}

export type FollowButtonProps = {
  organizer: Organizer;
  pageArea?: string;
  followStatus?: FollowStatus | null;
  followStatusLoading?: boolean;
  variant?: FollowButtonVariant;
};
